import { placesByLocationName } from '@/mapbox/client';

export const fetchLocationAutocomplete = async (query: string) =>
  placesByLocationName(query).then(response => response.features.map(feature => feature.place_name_it));
